import _regeneratorRuntime from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import HKDF from 'bcrypto/lib/hkdf';
import x25519 from 'bcrypto/lib/js/x25519';
import SHA256 from 'bcrypto/lib/js/sha256';
import { Buffer } from "buffer";
import PeerId from "peer-id";
import { keys } from 'libp2p-crypto';
import { pb } from "./proto/payload";
var NoiseHandshakePayloadProto = pb.NoiseHandshakePayload;
export function generateKeypair() {
  var privateKey = x25519.privateKeyGenerate();
  var publicKey = x25519.publicKeyCreate(privateKey);
  return {
    publicKey: publicKey,
    privateKey: privateKey
  };
}
export function getPayload(_x, _x2, _x3) {
  return _getPayload.apply(this, arguments);
}

function _getPayload() {
  _getPayload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(localPeer, staticPublicKey, earlyData) {
    var signedPayload, earlyDataPayload;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return signPayload(localPeer, getHandshakePayload(staticPublicKey));

          case 2:
            signedPayload = _context.sent;
            earlyDataPayload = earlyData || Buffer.alloc(0);
            _context.next = 6;
            return createHandshakePayload(localPeer.marshalPubKey(), signedPayload, earlyDataPayload);

          case 6:
            return _context.abrupt("return", _context.sent);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getPayload.apply(this, arguments);
}

export function createHandshakePayload(_x4, _x5, _x6) {
  return _createHandshakePayload.apply(this, arguments);
}

function _createHandshakePayload() {
  _createHandshakePayload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(libp2pPublicKey, signedPayload, earlyData) {
    var payloadInit;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            payloadInit = NoiseHandshakePayloadProto.create({
              identityKey: libp2pPublicKey,
              identitySig: signedPayload,
              data: earlyData || null
            });
            return _context2.abrupt("return", Buffer.from(NoiseHandshakePayloadProto.encode(payloadInit).finish()));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _createHandshakePayload.apply(this, arguments);
}

export function signPayload(_x7, _x8) {
  return _signPayload.apply(this, arguments);
}

function _signPayload() {
  _signPayload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(peerId, payload) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", peerId.privKey.sign(payload));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _signPayload.apply(this, arguments);
}

export function getPeerIdFromPayload(_x9) {
  return _getPeerIdFromPayload.apply(this, arguments);
}

function _getPeerIdFromPayload() {
  _getPeerIdFromPayload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return PeerId.createFromPubKey(Buffer.from(payload.identityKey));

          case 2:
            return _context4.abrupt("return", _context4.sent);

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getPeerIdFromPayload.apply(this, arguments);
}

export function decodePayload(_x10) {
  return _decodePayload.apply(this, arguments);
}

function _decodePayload() {
  _decodePayload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", NoiseHandshakePayloadProto.toObject(NoiseHandshakePayloadProto.decode(Buffer.from(payload))));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _decodePayload.apply(this, arguments);
}

export function getHandshakePayload(publicKey) {
  return Buffer.concat([Buffer.from("noise-libp2p-static-key:"), publicKey]);
}

function isValidPeerId(_x11, _x12) {
  return _isValidPeerId.apply(this, arguments);
}
/**
 * Verifies signed payload, throws on any irregularities.
 * @param {bytes} noiseStaticKey - owner's noise static key
 * @param {bytes} payload - decoded payload
 * @param {PeerId} remotePeer - owner's libp2p peer ID
 * @returns {Promise<PeerId>} - peer ID of payload owner
 */


function _isValidPeerId() {
  _isValidPeerId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(peerId, publicKeyProtobuf) {
    var generatedPeerId;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return PeerId.createFromPubKey(publicKeyProtobuf);

          case 2:
            generatedPeerId = _context6.sent;
            return _context6.abrupt("return", generatedPeerId.id.equals(peerId));

          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _isValidPeerId.apply(this, arguments);
}

export function verifySignedPayload(_x13, _x14, _x15) {
  return _verifySignedPayload.apply(this, arguments);
}

function _verifySignedPayload() {
  _verifySignedPayload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(noiseStaticKey, payload, remotePeer) {
    var identityKey, generatedPayload, publicKey;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            identityKey = Buffer.from(payload.identityKey);
            _context7.next = 3;
            return isValidPeerId(remotePeer.id, identityKey);

          case 3:
            if (_context7.sent) {
              _context7.next = 5;
              break;
            }

            throw new Error("Peer ID doesn't match libp2p public key.");

          case 5:
            generatedPayload = getHandshakePayload(noiseStaticKey); // Unmarshaling from PublicKey protobuf

            publicKey = keys.unmarshalPublicKey(identityKey);

            if (!(!payload.identitySig || !publicKey.verify(generatedPayload, Buffer.from(payload.identitySig)))) {
              _context7.next = 9;
              break;
            }

            throw new Error("Static key doesn't match to peer that signed payload!");

          case 9:
            return _context7.abrupt("return", PeerId.createFromPubKey(identityKey));

          case 10:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _verifySignedPayload.apply(this, arguments);
}

export function getHkdf(ck, ikm) {
  var info = Buffer.alloc(0);
  var prk = HKDF.extract(SHA256, ikm, ck);
  var okm = HKDF.expand(SHA256, prk, info, 96);
  var k1 = okm.slice(0, 32);
  var k2 = okm.slice(32, 64);
  var k3 = okm.slice(64, 96);
  return [k1, k2, k3];
}
export function isValidPublicKey(pk) {
  return x25519.publicKeyVerify(pk.slice(0, 32));
}